import React, { useState, useEffect } from "react";
import { DataView } from "primereact/dataview";
import { Tag } from "primereact/tag";
import user from "../images/user.svg";
import { API_IP, API_PORT } from "./AppConfig/AppConfig";
import { Paginator } from "primereact/paginator";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { Card } from "primereact/card";

export default function Users({setSidebarVisible}) {
  const [users, setUsers] = useState([]);
  const [getAll, setGetAll] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalElements, setTotalElements] = useState(null);
  const [loader, setLoader] = useState(true);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [textValue, setTextValue] = useState(null);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const onTextChange = async (event) => {
    try {
      // Filter the users based on the search text and user id
      setTextValue(event.target.value);
      const onfilteredUsers = getAll.filter(
        (user) =>
          turkishToLower(user.id).includes(
            turkishToLower(event.target.value)
          ) ||
          turkishToLower(user.email).includes(
            turkishToLower(event.target.value)
          ) ||
          turkishToLower(user.gsm).includes(turkishToLower(event.target.value))
      );
      setFilteredUsers(onfilteredUsers);
    } catch (error) {
      console.error(error);
    }
  };

  function turkishToLower(text) {
    return text.toLocaleLowerCase("tr-TR");
  }

  useEffect(() => {
    const fetchToken = async () => {
      try {
        // Token'ı almak için POST isteği yapalım
        const tokenResponse = await fetch(
          `http://${API_IP}:${API_PORT}/api/auth`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: "kimlik",
              password: "ff147b70-6b7a-482a-82f4-23ecc5186c54",
            }),
          }
        );

        if (!tokenResponse.ok) {
          throw new Error("Token alınırken bir hata oluştu");
        }

        const tokenData = await tokenResponse.json();
        const token = tokenData.data.token; // Token'ı alın
        // Sonrasında token ile getAllUsers API'sine istek yapalım

        const response = await fetch(
          `http://${API_IP}:${API_PORT}/api/id?page=${
            first / rows
          }&size=${rows}&sort=id,desc`,
          {
            headers: {
              Authorization: `kimlik ${token}`, // Token'ı Authorization başlığına ekleyin
            },
          }
        );

        if (!response.ok) {
          throw new Error("Kullanıcı verisi çekme hatası");
        }

        const jsonData = await response.json();
        setUsers(jsonData.data);
        setTotalElements(jsonData.properties.totalElements);
        setLoader(false);

        try {
          const response = await fetch(
            `http://${API_IP}:${API_PORT}/api/findByAllId`,
            {
              headers: {
                Authorization: `kimlik ${token}`, // Token'ı Authorization başlığına ekleyin
              },
            }
          );
          const jsonData = await response.json();
          setGetAll(jsonData);
        } catch (error) {
          throw new Error("Kullanıcı verisi çekme hatası");
        }
      } catch (error) {
        console.error("Hata:", error);
        setLoader(true);
      }
    };

    fetchToken();
  }, [first, rows]);

  const LoaderComp = () => {
    return (
      <div className="flex w-full flex-column xl:flex-row xl:align-items-start p-4 gap-4">
        <Skeleton className="w-4 sm:w-8rem xl:w-6rem shadow-2 h-6rem block xl:block mx-auto border-round" />
        <div className="flex w-full flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
          <div className="flex w-full flex-column align-items-center sm:align-items-start gap-3">
            <Skeleton className="w-12rem border-round h-2rem" />
            <Skeleton className="w-full border-round h-1rem" />
            <div className="flex align-items-center gap-3">
              <Skeleton className="w-12rem border-round h-1rem" />
              <Skeleton className="w-12rem border-round h-1rem" />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const itemTemplate = (item) => {
    return (
      <div key={item.id} className="col-12">
        <div className="flex flex-column xl:flex-row xl:align-items-start p-4  gap-4">
          <img
            className="w-4 sm:w-8rem xl:w-6rem shadow-2 block xl:block mx-auto border-round"
            src={user}
            alt="Kullanıcı"
          />
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-5">
            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
              <div className="flex items-center">
                <span className="text-2xl font-bold text-900">
                  {item.id}
                  {item.twoFactorAuthentication ? (
                    <i
                      className="pi pi-verified ml-2"
                      style={{ color: "green" }}
                    ></i>
                  ) : (
                    <i
                      className="pi pi-times-circle ml-2"
                      style={{ color: "red" }}
                    ></i>
                  )}
                </span>
              </div>
              <div className="flex flex-row align-items-center sm:align-items-start gap-3">
                <div className="text-m text-700 flex align-items-center">
                  <i
                    className="pi pi-envelope mr-2"
                    style={{ color: "purple" }}
                  ></i>
                  {item.email}
                </div>
                <div className="mx-4 text-m text-700 flex align-items-center">
                  |
                </div>
                <div className="text-m text-700">
                  <i
                    className="pi pi-phone mr-2"
                    style={{ color: "green" }}
                  ></i>
                  {item.gsm}
                </div>
                <div className="mx-4 text-m text-700">|</div>

                <div className="text-m text-700 flex align-items-center">
                  <i className="pi pi-key mr-2" style={{ color: "orange" }}></i>
                  User Token :
                </div>
                <div className="text-m text-700">{item.token}</div>
              </div>
              <div className="flex align-items-center gap-3">
                <span className="flex align-items-center gap-2">
                  <span className="font-semibold">Durum : </span>
                </span>
                {item.status === "ACTIVE" ? (
                  <Tag severity="success" value="AKTİF"></Tag>
                ) : (
                  <Tag severity="warning" value="PASİF"></Tag>
                )}
                <span className="flex align-items-center gap-2">
                  <span className="font-semibold">Müsaitlik : </span>
                </span>
                {item.availability === "ACTIVE" ? (
                  <Tag severity="success" value="AKTİF"></Tag>
                ) : (
                  <Tag severity="warning" value="PASİF"></Tag>
                )}
                <span className="flex align-items-center gap-2">
                  <span className="font-semibold">Parola : </span>
                </span>
                <Tag severity="info" value={item.password}></Tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="card p-4 bg-blue-50 w-full">
      <div className="card mb-2 mx-3 flex md:flex-row gap-3">
        <Button
          onClick={() => setSidebarVisible((visible) => !visible)}
          icon="pi pi-bars"
          severity="info"
        ></Button>
        <div className="p-inputgroup flex-1">
          <InputText
            placeholder="Aramak için metin giriniz"
            onKeyUp={(e) => onTextChange(e)}
          />
          <Button severity="warning" label="Ara" icon="pi pi-search" />
        </div>
      </div>
      {getAll.length > 0 ? (
        <>
          {!loader ? (
            filteredUsers.length === 0 && textValue !== null ? (
              <div className="py-4 ">
                <Card
                  className="bg-blue-200 ml-3 "
                  title="Veri bulunamadı"
                ></Card>
              </div>
            ) : (
              <DataView
                className="ml-3 "
                value={
                  filteredUsers.length > 0 && filteredUsers.length < 400
                    ? filteredUsers
                    : users
                }
                itemTemplate={itemTemplate}
              />
            )
          ) : (
            <div className="w-full col-12">
              <LoaderComp />
              <LoaderComp />
              <LoaderComp />
            </div>
          )}
          {filteredUsers.length > 0 && filteredUsers.length < 400 ? null : (
            <Paginator
              className="mt-4 bg-blue-50"
              first={first}
              rows={rows}
              totalRecords={totalElements}
              rowsPerPageOptions={[10, 20, 30]}
              onPageChange={onPageChange}
            />
          )}
        </>
      ) : (
        <div className="w-full col-12">
          <LoaderComp />
          <LoaderComp />
          <LoaderComp />
        </div>
      )}
    </div>
  );
}
